import { render, staticRenderFns } from "./MyProfileCreationItem.vue?vue&type=template&id=fbba8a04&scoped=true&"
import script from "./MyProfileCreationItem.vue?vue&type=script&lang=js&"
export * from "./MyProfileCreationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbba8a04",
  null
  
)

export default component.exports